import React from 'react';
import { useNotify } from 'react-admin';

import { uploadFile } from '../../../../api/uploadFile';
import { useNotifyError } from '../../../../utils/notifiers/useNotifyError';

export const useEntityFileUpload = (handleAdded, entityId, resource) => {
	const notify = useNotify(false);
	const notifyError = useNotifyError();	
	const [ uploaded, setUploaded ] = React.useState(undefined);
	const [ uploading, setUploading ] = React.useState(false);

	const resetUpload = React.useCallback(() => {
		setUploaded(undefined);
	}, []);

	const handleUploadFile = React.useCallback(async (file, body=null) => {
		setUploading(true);
		const requestBody = {
			...(body || {}),
		};

		try {
			const uploadResponse = await uploadFile(
				`files/${resource}/${entityId}/documents`,
				file,
				requestBody
			);
			setUploaded(uploadResponse.document);
			handleAdded();
		} catch(error) {
			if (error.body && error.body.message) {
				notify(error.body.message, "error");
			} else if (error.status === 413) {
				notify("File is too large", "error");
			} else {
				notifyError(error);
			}
			console.dir(error);
		} finally {
			setUploading(false);
		}
	}, [resource, entityId, handleAdded, notifyError, notify]);

	return [ uploading, handleUploadFile, uploaded, resetUpload ];
};
